import type { LiveDropInfoResponse } from '../../../../../live-drop-info/types';
import { GlobalLinks } from '#lib/features/navigation/constants/global-links.js';

export const getGlobalLinks = (liveDropInfo: LiveDropInfoResponse | null) => {
	// Live status is presented on the Works page itself. The primary navigation
	// must remain stable: changing Works into a release link when exactly one
	// drop is live makes the archive unexpectedly unreachable.
	void liveDropInfo;

	return GlobalLinks.map((link) => ({
		...link,
		items: link.items?.map((item) => ({ ...item })),
	}));
};
